<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-upload
			  class="avatar-uploader"
			  action="https://server.walkertour.cn/spa/info/uploadCaseFile"
			  :headers="headers"
			  :data="data"
			  multiple
			  accept="image/png, image/jpeg"
			  :show-file-list="false"
			  :on-success="handleAvatarSuccess"
			  :before-upload="beforeAvatarUpload"
			  rossorigin="anonymous"
			>
			  <el-button link type="primary" size="small">添加轮播图</el-button>
			</el-upload>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%">
		<el-table-column label="预览" width="260">
		  <template #default="scope">
			<div style="display: flex; align-items: center">
			  <el-image style="width: 100px; height: 100px" :src="scope.row.url" fit="contain" />
			</div>
		  </template>
		</el-table-column>
		<el-table-column label="路径" width="580">
		  <template #default="scope">
			<div style="display: flex; align-items: center">
			  <span style="margin-left: 10px">{{ scope.row.url }}</span>
			</div>
		  </template>
		</el-table-column>
		<el-table-column label="操作">
		  <template #default="scope">
			<el-button
			  size="small"
			  type="danger"
			  @click="handleDelete(scope.$index, scope.row)"
			>
			  删除
			</el-button>
		  </template>
		</el-table-column>
	</el-table>
</template>

<script setup>
	import { ref,inject,onMounted,provide  } from 'vue'
	import axios from 'axios';
	import { useMemberStore } from '../../../stores';
	import { ElMessage } from 'element-plus'
	const userStore = useMemberStore();
	const baseURL = 'https://devmini.walkertour.cn';
	const rootPath = "/www/wwwroot/testMiniServer/server/dist";
	const headers = ref({
		'Authorization': `${userStore.profile?.token}`,
	})
	const data = ref({})
	const handleAvatarSuccess= (
	  response,
	  uploadFile
	) => {
	  if(response.status===0){
		response.imgUrl.replace(rootPath,baseURL);
		ElMessage({
			message: '上传成功!',
			type: 'success',
		})
	  }
	}
	const beforeAvatarUpload = (rawFile) => {
	  if (rawFile.type !== 'image/jpg'&&rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
	    ElMessage.error('Avatar picture must be JPG/PNG format!')
	    return false
	  } else if (rawFile.size / 1024 / 1024 > 12) {
	    ElMessage.error('Avatar picture size can not exceed 12MB!')
	    return false
	  }
	  return true
	}
	const billid = inject('billid');
	
	onMounted(()=>{
		data.value = {
			billid:billid.value
		}
		fetchOrders();
	})
	
	const fetchOrders = async() =>{
		const response = await axios.post('/spa/info/queryCarouselList', {
		  billid:billid.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			'Authorization': `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data
		}
	}
	
	const tableData = ref([])
	const handleDelete = async(index, row) => {
		console.log(index, row)
		const response = await axios.post('/spa/info/delCarouselInfo', {
			billid:row.id
			}, {
			headers: {
			  'Content-Type': 'application/json',
			  'Authorization': `${userStore.profile?.token}`,
			}
		});
		if(response.data.status===0){
			fetchOrders();
			ElMessage({
				message: '删除成功!',
				type: 'success',
			})
		}
	}
</script>
<style scoped>
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
</style>